import { render, staticRenderFns } from "./Createsqa.vue?vue&type=template&id=06dc2ca3&scoped=true"
import script from "./Createsqa.vue?vue&type=script&lang=js"
export * from "./Createsqa.vue?vue&type=script&lang=js"
import style0 from "./Createsqa.vue?vue&type=style&index=0&id=06dc2ca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc2ca3",
  null
  
)

export default component.exports